import { useState, createContext } from 'react';
import { useGetPlanoUsuario } from '@api/controllers/planoUsuario';
import { useSelect } from '@wordpress/data';
import { store } from '../../../redux/store';

const ContextSearch = createContext();

export function ContextSearchProvider({ children }) {
  const [search, setSearch] = useState('');
  const [gratuito, setGratuito] = useState(false);
  const [notFound, setNotFound] = useState(false);
  const { data: dataPlanoUsuario } = useGetPlanoUsuario(
    useSelect(select => select(store).getUsuarioIdOpti()) || 0
  );

  const contextValue = {
    search,
    setSearch,
    gratuito,
    setGratuito,
    notFound,
    setNotFound,
    dataPlanoUsuario,
  };

  return <ContextSearch.Provider value={contextValue}>{children}</ContextSearch.Provider>;
}

export default ContextSearch;
